import styled from 'styled-components';
import { Card } from 'antd';

export const ImageContainer = styled.div`
	margin-bottom: 1rem;
	border-radius: 0.5rem;
	width: 25rem;
	height: 15rem;
	overflow: hidden;
	display: flex;
	justify-content: center;
	align-items: center;
	background-color: #f0f0f0;
	img {
		max-width: 100%;
		max-height: 100%;
		object-fit: cover;
	}
`;

export const ImageCard = styled(Card)`
	border: 2px solid #ebebeb;
	border-radius: 0.5rem;
	height: 15rem;
	.ant-card-head {
		background-color: #ebebeb;
	}
	.ant-card-head-title {
		font-weight: bold;
	}
`;
